
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface SocialMediaFieldsProps {
  instagram: string;
  tiktok: string;
  facebook: string;
  pinterest: string;
  onSocialMediaChange: (platform: string, value: string) => void;
}

export const SocialMediaFields = ({
  instagram,
  tiktok,
  facebook,
  pinterest,
  onSocialMediaChange,
}: SocialMediaFieldsProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-black">Social Media Handles</h3>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="instagram" className="text-black">Instagram</Label>
          <Input
            id="instagram"
            placeholder="@username"
            value={instagram}
            onChange={(e) => onSocialMediaChange("instagram_handle", e.target.value)}
            className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
          />
        </div>
        <div>
          <Label htmlFor="tiktok" className="text-black">TikTok</Label>
          <Input
            id="tiktok"
            placeholder="@username"
            value={tiktok}
            onChange={(e) => onSocialMediaChange("tiktok_handle", e.target.value)}
            className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
          />
        </div>
        <div>
          <Label htmlFor="facebook" className="text-black">Facebook</Label>
          <Input
            id="facebook"
            placeholder="username or profile URL"
            value={facebook}
            onChange={(e) => onSocialMediaChange("facebook_handle", e.target.value)}
            className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
          />
        </div>
        <div>
          <Label htmlFor="pinterest" className="text-black">Pinterest</Label>
          <Input
            id="pinterest"
            placeholder="@username"
            value={pinterest}
            onChange={(e) => onSocialMediaChange("pinterest_handle", e.target.value)}
            className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
          />
        </div>
      </div>
    </div>
  );
};
